import React from 'react';
import { createIcon } from '@chakra-ui/react';

export const WaterIcon = createIcon({
	viewBox: '0 0 20 20',
	path: (
		<path d="M 9.999 1 C 9.999 1 2.687 6.806 2.687 11.688 C 2.687 15.726 5.961 19 9.999 19 C 14.039 19 17.313 15.726 17.313 11.688 C 17.313 6.806 9.999 1 9.999 1 Z M 9.999 17.312 C 6.895 17.312 4.375 14.792 4.375 11.688 C 4.375 8.908 7.863 5.162 9.999 3.216 C 12.137 5.162 15.625 8.898 15.625 11.688 C 15.625 14.792 13.105 17.312 9.999 17.312 Z M 6.659 12.172 C 6.929 14.038 8.673 15.288 10.483 15.028 C 10.821 14.984 11.125 15.242 11.125 15.58 C 11.125 15.894 10.899 16.108 10.653 16.142 C 8.143 16.492 5.905 14.758 5.545 12.328 C 5.499 11.992 5.759 11.688 6.107 11.688 C 6.389 11.688 6.625 11.89 6.659 12.172 Z" />
	),
});
